export type TermsAcceptedClassProps = {
    termsAndConditionsV1: boolean;
    privacyPolicyV1: boolean;
};

export default class TermsAccepted {
    public readonly termsAndConditionsV1: boolean;
    public readonly privacyPolicyV1: boolean;

    constructor(props: TermsAcceptedClassProps) {
        this.termsAndConditionsV1 = props.termsAndConditionsV1;
        this.privacyPolicyV1 = props.privacyPolicyV1;
    }
}
